import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import PropTypes from 'prop-types'
import ButtonCta from '@components/atoms/button-cta'
import { forwardRef } from 'react'
import useStyles from './hero-secondary-wrapper.styles'

const HeroSecondaryWrapper = forwardRef((props, ref) => {
  const {
    featuredEvent,
  } = props

  const {
    headline, startDate, endDate,
  } = featuredEvent

  // Fix Safari handling of date format
  const start = new Date(startDate.replace(/ /g, 'T'))
  const end = new Date(endDate.replace(/ /g, 'T'))
  const dateDayMonth = {
    month: 'long',
    day: 'numeric',
  }
  const dateDayMonthYear = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  const startFormatted = start.toLocaleDateString('en-US', dateDayMonth)
  const endFormatted = end.toLocaleDateString('en-US', dateDayMonthYear)

  const styles = useStyles()
  return (
    <Box ref={ref} className={styles.root}>
      <Container>
        <Box py={3} className={styles.container}>
          <Box className={styles.headlineContainer}>
            <Typography variant="overline" className={styles.overline}>Featured Event</Typography>
            <Typography variant="h5" variantMapping={{ h5: 'h2' }} className={styles.headline}>{headline}</Typography>
            <Typography variant="body1">{`${startFormatted}-${endFormatted}`}</Typography>
          </Box>
          <Box className={styles.ctaContainer}>
            <ButtonCta
              className={styles.ctaButton}
              variant="outlined"
              color="primary"
              reference={featuredEvent}
              dataAttrs={{ 'aria-label': `View event details for ${headline}` }}
            >
              View Event
            </ButtonCta>
          </Box>
        </Box>
      </Container>
    </Box>
  )
})

HeroSecondaryWrapper.propTypes = {
  hero: PropTypes.shape({
    headline: PropTypes.string,
    summary: PropTypes.string,
    ctaText: PropTypes.string,
    externalLink: PropTypes.string,
    reference: PropTypes.shape({
      __typename: PropTypes.string,
      slug: PropTypes.string,
    }),
  }),
  secondaryCtaText: PropTypes.string,
  secondaryCtaLink: PropTypes.string,
}

HeroSecondaryWrapper.defaultProps = {

}

export default HeroSecondaryWrapper
